<app-navbar [name]="name$"></app-navbar>
  <app-datatable></app-datatable>